import {
  Button,
  FormInput,
  FormPassword,
  FormRoot,
  FormSelect,
  RHF,
  zodResolver,
} from "@devhop/ui";
import { z } from "zod";

const STAFF_ROLE_OPTIONS = [
  { value: "owner", label: "ເຈົ້າຂອງຮ້ານ" },
  { value: "manager", label: "ຜູ້ຈັດການ" },
  { value: "cashier", label: "ເກັບເງິນ" },
] as const;

const AddStaffFormSchema = z.object({
  email: z.string().email("ກະລຸນາໃສ່ອີເມວໃຫ້ຖືກຕ້ອງ"),
  name: z.string().min(1, "ຕ້ອງໃສ່ຊື່"),
  password: z.string().min(6, "ລະຫັດຜ່ານຕ້ອງຢ່າງນ້ອຍ 6 ຕົວອັກສອນ"),
  staffRole: z.enum(["owner", "manager", "cashier"]),
});

export type AddStaffFormValues = z.infer<typeof AddStaffFormSchema>;

export function AddStaffForm({
  onSubmit,
  submitting,
}: {
  onSubmit: (values: AddStaffFormValues) => void;
  submitting?: boolean;
}) {
  const methods = RHF.useForm<AddStaffFormValues>({
    resolver: zodResolver(AddStaffFormSchema),
    defaultValues: {
      email: "",
      name: "",
      password: "",
      staffRole: "owner",
    },
  });

  return (
    <FormRoot<AddStaffFormValues>
      methods={methods}
      onSubmit={onSubmit}
      className="space-y-4"
    >
      <FormInput
        name="email"
        label="ອີເມວ"
        type="email"
        requiredMark
        placeholder="name@example.com"
      />
      <FormInput name="name" label="ຊື່" requiredMark placeholder="ຊື່ພະນັກງານ" />
      <FormPassword
        name="password"
        label="ລະຫັດຜ່ານ"
        placeholder="********"
        requiredMark
      />
      <FormSelect
        name="staffRole"
        label="ບົດບາດ"
        requiredMark
        options={STAFF_ROLE_OPTIONS}
      />
      <div className="flex justify-end gap-2 pt-2">
        <Button type="submit" isLoading={submitting}>
          ເພີ່ມພະນັກງານ
        </Button>
      </div>
    </FormRoot>
  );
}
